import { render, staticRenderFns } from "./RanksIndex.vue?vue&type=template&id=bef416e2&"
import script from "./RanksIndex.vue?vue&type=script&lang=js&"
export * from "./RanksIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports